import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { USER_DETAIL } from "../redux/Slices/AuthSlice";
import {
	editprofileapi,
	getpatientprofileapi,
	signupCity,
	signupCountry,
	signupStates,
} from "../network/Network";

const PersonalInfo = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userDetail = useSelector((state) => state?.Auth?.users);
	const token = useSelector((state) => state?.Auth?.token);
	const [formErrors, setFormErrors] = useState([]);
	const [isOfficeChecked, setIsOfficeChecked] = useState(
		userDetail?.address_type,
	);
	console.log(userDetail, "userDetail");
	const [getCountry, setGetcountry] = useState([]);
	const [getCountryid, setGetCountryid] = useState("");
	const [getCityid, setGetCityid] = useState("");
	const [getCity, setGetCity] = useState([]);
	const [getState, setGetState] = useState([]);
	const [getStateid, setGetStateid] = useState("");
	const [loading, setLoading] = useState(false);
	const [selected, setSelected] = useState("");
	const [userData, setUserData] = useState({
		first_name: userDetail?.first_name,
		last_name: userDetail?.last_name,
		phone: userDetail?.phone?.replace(/^\+1|\+44/, "") || "",
		countryCode: userDetail?.phone?.startsWith("+44") ? "+44" : "+1", // default to +1
		address: userDetail?.address,
		country: userDetail?.country,
		city: userDetail?.city,
		state: userDetail?.state,
		zip_code: userDetail?.zip_code,
	});

	useEffect(() => {
		getpatientprofileapi(token).then((res) => {
			console.log(res?.data?.data, "asdkkas2");
		});
	}, []);

	useEffect(() => {
		signupCountry().then((res) => {
			setGetcountry(res?.data?.data);
		});
	}, []);

	// State API call based on selected country
	useEffect(() => {
		if (getCountryid) {
			signupStates(getCountryid)
				.then((res) => {
					setGetState(res?.data?.data);
				})
				.catch((err) => {});
		}
	}, [getCountryid]);

	// City API call based on selected state
	useEffect(() => {
		if (getStateid) {
			signupCity(getStateid)
				.then((res) => {
					setGetCity(res?.data?.data);
				})
				.catch((err) => {});
		}
	}, [getStateid]);

	const handleCountryChange = (e) => {
		setGetCountryid(e.target.value);
	};

	const handleStateChange = (e) => {
		setGetStateid(e.target.value);
	};

	const handleCityChange = (e) => {
		setGetCityid(e.target.value);
	};

	//  Check box handler
	const handleOfficeCheckboxChange = (event) => {
		setIsOfficeChecked(event.target.value);
	};
	// ===============

	//   Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================
	const handleCountryCode = (e) => {
		const value = e.target.value;
		setUserData((prev) => ({
			...prev,
			countryCode: value,
			phone: "",
		}));
		// setUserData({ ...userData, phone: "" });
		// setUserData({ ...userData, countryCode: value });
	};

	//   Edit Profile Handler
	const editprofilehandler = (e) => {
		e.preventDefault();
		setLoading(true);
		let isValid = true;
		const errors = {};

		// Validate First Name
		if (!userData || !userData.first_name) {
			if (!errors || !errors.first_name) {
				if (!errors) errors = {};
				errors.first_name = [];
			}
			errors.first_name.push("First Name is required");
			isValid = false;
		}

		// Validate Last Name
		if (!userData || !userData.last_name) {
			if (!errors || !errors.last_name) {
				if (!errors) errors = {};
				errors.last_name = [];
			}
			errors.last_name.push("Last Name is required");
			isValid = false;
		}

		// Validate Phone Number
		if (!userData?.phone) {
			errors.phone = ["Phone is required"];
			isValid = false;
		} else {
			const phone = userData.phone.trim();

			if (userData.countryCode === "+1") {
				if (!/^\d{10}$/.test(phone)) {
					errors.phone = ["USA phone number must be exactly 10 digits"];
					isValid = false;
				}
			} else if (userData.countryCode === "+44") {
				if (!/^\d{8,10}$/.test(phone)) {
					errors.phone = ["UK phone number must be between 8 and 10 digits"];
					isValid = false;
				}
			} else {
				errors.phone = ["Invalid country code selected"];
				isValid = false;
			}
		}

		// Validate Address
		if (!userData || !userData.address) {
			if (!errors || !errors.address) {
				if (!errors) errors = {};
				errors.address = [];
			}
			errors.address.push("Address is required");
			isValid = false;
		}

		// Validate country
		if (!userData || !userData.country) {
			if (!errors || !errors.country) {
				if (!errors) errors = {};
				errors.country = [];
			}
			errors.country.push("Country is required");
			isValid = false;
		}
		// Validate city
		if (!userData || !userData.city) {
			if (!errors || !errors.city) {
				if (!errors) errors = {};
				errors.city = [];
			}
			errors.city.push("City is required");
			isValid = false;
		}

		// Validate state
		if (!userData || !userData.state) {
			if (!errors || !errors.state) {
				if (!errors) errors = {};
				errors.state = [];
			}
			errors.state.push("State is required");
			isValid = false;
		}

		// Validate zip_code
		if (!userData || !userData.zip_code) {
			if (!errors || !errors.zip_code) {
				if (!errors) errors = {};
				errors.zip_code = [];
			}
			errors.zip_code.push("Zip Code/Postal Code is required");
			isValid = false;
		}

		setFormErrors(errors);

		let data = {
			first_name: userData?.first_name,
			last_name: userData?.last_name,
			phone: `${userData.countryCode}${userData.phone.trim()}`,
			address: userData?.address,
			country: userData?.country,
			city: userData?.city,
			state: userData?.state,
			zip_code: userData?.zip_code,
			address_type: isOfficeChecked,
		};

		editprofileapi(userDetail?.id, data, token)
			.then((res) => {
				setFormErrors([]);

				dispatch(USER_DETAIL(res?.data?.data));
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Profile has been updated successfully",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate("/personal-info");
				setLoading(false);

				// setEditProfile(false);
			})
			.catch((err) => {
				// Swal.fire({
				//   text: err.errors,
				//   icon: "error",
				// });
				setFormErrors([]);

				const errorData = err?.response?.data?.errors;

				if (errorData) {
					Object.values(errorData)
						.flat()
						.forEach((message) => {
							Swal.fire({
								position: "center",
								icon: "error",
								text: message,
								showConfirmButton: false,
								timer: 2200,
							});
						});
				}

				setLoading(false);
			});
	};
	// ====================

	return (
		<>
			<Header />
			<PageHeader pagename="Edit Personal Info" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link to="/personal-info">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Edit Personal Info
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="firstName"
												name="first_name"
												placeholder=" First Name"
												value={userData?.first_name}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.first_name}</p>
										</div>
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" Last Name"
												name="last_name"
												value={userData?.last_name}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.last_name}</p>
										</div>
									</div>
									<div className="form-group col-lg-12">
										{/* <input
											type="text"
											className="form-control"
											id="country"
											placeholder="Enter email"
											name="country"
											value={userData?.country}
											onChange={handleChange}
										/> */}
										<input
											type="text"
											className="form-control"
											id="state"
											placeholder="Country"
											name="country"
											value={userData?.country}
											onChange={handleChange}
										/>
										<p className="forms-error">{formErrors?.country}</p>
									</div>
									<div className="form-group col-lg-12">
										<div className="input-group vertical-ll">
											<select
												className="form-control"
												style={{
													maxWidth: "100px",
													borderRadius: "80px 0 0px 80px",
													border: "1px solid #869b96",
													background: "transparent",
												}}
												value={userData?.countryCode}
												name="countryCode"
												onChange={handleCountryCode}
											>
												<option value="+1">+1 (USA)</option>
												<option value="+44">+44 (UK)</option>
											</select>
											<input
												type="tel"
												className="form-control"
												id="phone"
												placeholder="Phone number"
												name="phone"
												value={userData?.phone}
												onChange={(e) => {
													const value = e.target.value.replace(/\D/g, ""); // remove non-digits
													if (value.length <= 10) {
														handleChange({
															target: { name: "phone", value },
														});
													}
												}}
												maxLength={10}
											/>
										</div>
										<p className="forms-error">{formErrors?.phone}</p>
									</div>
									<div className="form-group col-lg-12 position-relative">
										<input
											type="text"
											className="form-control"
											id="address"
											placeholder="Address"
											name="address"
											value={userData?.address}
											onChange={handleChange}
										/>
										<p className="forms-error">{formErrors?.address}</p>
										<div className="d-flex align-items-center gap-2">
											<div className="checkbox-container d-flex align-items-center gap-2">
												<input
													type="checkbox"
													id="home"
													value="home"
													className="custom-checkbox"
													checked={isOfficeChecked === "home"}
													onChange={handleOfficeCheckboxChange}
												/>
												<label
													className="mb-0 extra-color-15 level-7"
													htmlFor="home"
												>
													Home
												</label>
											</div>
											<div className="checkbox-container d-flex align-items-center gap-2">
												<input
													type="checkbox"
													id="office"
													value="office"
													className="custom-checkbox"
													checked={isOfficeChecked === "office"}
													onChange={handleOfficeCheckboxChange}
												/>
												<label
													className="mb-0 extra-color-15 level-7"
													htmlFor="office"
												>
													Office
												</label>
											</div>
											<p className="forms-error">
												{formErrors?.isOfficeChecked}
											</p>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-4">
											{/* <input
												type="text"
												className="form-control"
												id="state"
												placeholder="State"
												name="state"
												value={userData?.state}
												onChange={handleChange}
											/> */}
											{/* <select id="idstateSelect" onChange={handleStateChange}>
												<option>Choose a state</option>
												{getState?.map((state) => (
													<option key={state?.id} value={state?.id}>
														{state?.name}
													</option>
												))}
											</select> */}
											<input
												type="text"
												className="form-control"
												id="state"
												placeholder="State"
												name="state"
												value={userData?.state}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.state}</p>
										</div>
										<div className="form-group col-lg-4">
											{/* <input
												type="text"
												className="form-control"
												id="city"
												placeholder=" City"
												name="city"
												value={userData?.city}
												onChange={handleChange}
											/> */}
											<input
												type="text"
												className="form-control"
												id="city"
												placeholder=" City"
												name="city"
												value={userData?.city}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.city}</p>
										</div>
										<div className="form-group col-lg-4">
											<input
												type="number"
												className="form-control"
												id="zip_code"
												placeholder=" Zip Code/Postal Code "
												name="zip_code"
												value={userData?.zip_code}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.zip_code}</p>
										</div>
									</div>
									<Link className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none">
										<span
											onClick={(e) => editprofilehandler(e)}
											className="loading-btn loading bg-wrapper "
										>
											{loading ? <i className="fa fa-spinner"></i> : "Save"}
										</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PersonalInfo;
